import { ConnectedAudiologistSortByParam } from "@bvhi/backend-api";
import { GridSortItem } from "@bvhi/ui-base";
import { useCallback } from "react";

export interface SortConfig {
  backendString: string;
  dataGridSortModel: GridSortItem;
}

const config: SortConfig[] = [
  {
    backendString: ConnectedAudiologistSortByParam.CHAIN_NUMBER_ASC,
    dataGridSortModel: {
      field: "chainNumber",
      sort: "asc",
    },
  },
  {
    backendString: ConnectedAudiologistSortByParam.CHAIN_NUMBER_DESC,
    dataGridSortModel: {
      field: "chainNumber",
      sort: "desc",
    },
  },
  {
    backendString: ConnectedAudiologistSortByParam.NAME_ASC,
    dataGridSortModel: {
      field: "organisationName",
      sort: "asc",
    },
  },
  {
    backendString: ConnectedAudiologistSortByParam.NAME_DESC,
    dataGridSortModel: {
      field: "organisationName",
      sort: "desc",
    },
  },
];

export const useAudiologistsSortParams = () => {
  const isFieldSortable = useCallback((fieldName: string): boolean => {
    const configItem = config.find((item) => item.dataGridSortModel.field === fieldName);
    if (configItem) return true;
    return false;
  }, []);

  const getSortModelForBackendString = useCallback((backendString: string): GridSortItem => {
    const item = config.find((item) => item.backendString === backendString);
    return item?.dataGridSortModel ?? config[0].dataGridSortModel;
  }, []);

  const getSortConfig = useCallback((sortModel?: GridSortItem) => {
    if (!sortModel) return config[0];
    const item = config.find((item) => item.dataGridSortModel.field === sortModel.field && item.dataGridSortModel.sort === sortModel.sort);
    return item ?? config[0];
  }, []);

  return { isFieldSortable, getSortConfig, getSortModelForBackendString };
};
